import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import { voidFunc } from 'common/utils/void-function'
import React from 'react'
import { CommonCoupon } from 'src/shared/components/coupon'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'

export const Coupon = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CouponInterface>) => {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonCoupon
        {...entity}
        id={entity.htmlAttrId}
        isChecking={false}
        onCodeChange={voidFunc}
        onCheck={voidFunc}
      />
    </BaseEntityNew>
  )
}
